import { Container } from "@mui/material"
import Header from "../components/shared/Header"
import Footer from "../components/shared/Footer"

export default function MainLayout({ children }) {
  return (
    <>
      <Header />
      <main>
        <Container disableGutters maxWidth={false}>
          {children}
        </Container>
      </main>
      <Footer />
    </>
  )
}
